module.exports = __webpack_public_path__ + "coin_MONERO.png?2d95271c9ff5a1e1fd1e15c125297a1e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_MONERO.png
// module id = 1111
// module chunks = 2